import { struct } from 'io-ts/Decoder';

import { ParentId } from '../../../comment/ParentId';

export const Params = struct({
	parentId: ParentId,
});
